import { DecodedTokenTypes } from '../interfaces/decodedToken'

export const navigateTo = (
  userType: DecodedTokenTypes['user_type'] | null | undefined,
) => {
  switch (userType) {
    case 'SUPER_ADMINISTRATOR':
      return '/super-admin'
    case 'ADMINISTRATOR':
      return '/admin'
    case 'COMPLIANCE_OFFICER':
      return '/compliance-officer'
    case 'HR':
      return '/hr'
    default:
      // EMPLOYEE, or a type this build does not know about: no area of its
      // own. Returning undefined here would make <Navigate> resolve to the
      // current path, leaving a signed-in user sitting on the login screen.
      return '/'
  }
}
